export default __webpack_public_path__ + "static/media/success.bbfd0cf7.svg";